import React from 'react';
import SettingsSalesOrders from './SettingsSalesOrders';

function SalesOrderSetupPage() {
  // SettingsSalesOrders has its own header
  return <SettingsSalesOrders />;
}

export default SalesOrderSetupPage;
